export { SimpleEventMobileInfo } from './SimpleEventMobileInfo';
